const PRISMIC_CLI_USER_AGENT = "prismic-cli";
export {
  PRISMIC_CLI_USER_AGENT
};
//# sourceMappingURL=PRISMIC_CLI_USER_AGENT.js.map
